<div class="headerFlexW pr-4 m-3">
    <div class="content-block">
        <p class="bread-crumbs"><a [routerLink]="['/dash/admin/dispersions/']">Dispersiones</a> / Detalle</p>
        <h2 class="">Dispersiones / Detalle</h2>
    </div>
</div>
<div class="content-block">
    <div class="dx-card responsive-paddings">
        <h2>Detalle de dispersión</h2>
        <div class="flex flex-nowrap flex-start datagrid-detailsW round-border-2">
            <div class="mr-5">
                <ul>
                    <li>Fecha de creación: {{dispersion.dateCreated|numberToDate}}</li>
                    <li>Fecha programada: {{dispersion.dateScheduled|numberToDate}}</li>
                    <li *ngIf="dispersion.dateExecuted">Fecha de ejecución:
                        {{dispersion.dateExecuted|numberToDate}}</li>
                    <li>Número de beneficiarios: {{dispersion.beneficiaries.length}}</li>
                    <li>Programa: {{dispersion.programName}}</li>
                    <li>Tipo de dispersión: {{dispersion.dispersionTypeName}}</li>
                    <li *ngIf="dispersion.recurrance">Recurrencia:
                        {{dispersion.recurrance.name}}</li>
                    <li>ID: {{dispersion.id}}</li>
                </ul>
            </div>
            <div class="">
                <ul>
                    <li>Cantidad a dispersar: {{dispersion.dispersionAmount|currency}}</li>
                    <li>Comisión: {{dispersion.fees | currency}}</li>
                    <li>IVA: {{dispersion.tax | currency}}</li>
                    <li>Gran total: {{dispersion.granTotal | currency}}</li>
                </ul>
            </div>
        </div>
    </div>
    <div class="dx-card responsive-paddings mt-5">
        <h2>Historial de dispersiones</h2>
        <dx-data-grid [dataSource]="dispersion.beneficiaries" [showBorders]="true">
            <dxo-load-panel [enabled]="true"></dxo-load-panel>
            <dxo-search-panel [visible]="true" [width]="240" placeholder="Buscar..."></dxo-search-panel>
            <dxi-column dataField="employeeName" caption="Nombre" cellTemplate="nameTemplate"></dxi-column>
            <dxi-column dataField="transactionDate" caption="Fecha de transacción" cellTemplate="dateTemplate"
                alignment="center">
            </dxi-column>
            <dxi-column dataField="transactionId" caption="Id de transacción" cellTemplate="dateTemplate"
                alignment="center">
            </dxi-column>
            <dxi-column dataField="amount" caption="Cantidad" dataType="number" format="currency" alignment="center">
                <dxo-format type="currency" [precision]="2"></dxo-format>
            </dxi-column>
            <div *dxTemplate="let d of 'dateTemplate'">
                <div *ngIf="d.value"> {{d.value|numberToDate}}</div>
            </div>
            <div *dxTemplate="let user of 'nameTemplate'">
                <div> {{user.data.employeeName}} {{user.data.employeeLastName}} {{user.data.employeeSecondLastName}}
                </div>
            </div>
        </dx-data-grid>
    </div>
</div>